import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import getLabel from './../../../../utils/labels';
import intro1 from '../../../../globals/images/intro1.png';
import intro2 from '../../../../globals/images/intro2.png';
import intro3 from '../../../../globals/images/intro3.png';
import styles from './introPage.module.scss';
import analytics from './../../../../utils/segmentUtils';

class IntroPage extends Component {
    componentDidMount() {
        analytics.page('Intro Page')
    }

    render() {
        let { introductionData } = this.props;
        let introImage1 = introductionData.introPage.step1Image ? introductionData.introPage.step1Image : intro1;
        let introImage2 = introductionData.introPage.step2Image ? introductionData.introPage.step2Image : intro2;
        let introImage3 = introductionData.introPage.step3Image ? introductionData.introPage.step3Image : intro3;

        return (
            <div className={styles['intro-page-wrapper']}>
                <div className={styles['title']}>
                    {getLabel('label_introduction_title')}
                </div>
                <div className={styles['intro-text']} dangerouslySetInnerHTML={{ __html: introductionData.introPage.content }} />
                <div className={styles['intro-images-container']}>
                    <div className={styles['intro-image-box']}>
                        <img src={introImage1} className={styles.person}></img>
                        <div className={styles['intro-image-desc']}>
                            {
                                introductionData.introPage.step1Header ?
                                    introductionData.introPage.step1Header :
                                    'About Company'
                            }
                        </div>
                    </div>

                    <div className={styles['image-connector-line']}></div>

                    <div className={styles['intro-image-box']}>
                        <img src={introImage2} className={styles.person}></img>
                        <div className={styles['intro-image-desc']}>
                            {
                                introductionData.introPage.step2Header ?
                                    introductionData.introPage.step2Header :
                                    'About Character'
                            }
                        </div>
                    </div>

                    <div className={styles['image-connector-line']}></div>

                    <div className={styles['intro-image-box']}>
                        <img src={introImage3} className={styles.person}></img>
                        <div className={styles['intro-image-desc']}>
                            {
                                introductionData.introPage.step3Header ?
                                    introductionData.introPage.step3Header :
                                    'Objective'
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

IntroPage.propTypes = {
    timeData: PropTypes.object
};

IntroPage.defaultProps = {
    timeData: {}
}

export default IntroPage;


// WEBPACK FOOTER //
// /src/components/intro/pages/introPage/IntroPage.js